import { E_ColoriMetallo } from "./enumerations";

// Codici dei colori delle strutture
export const codiciColoreMetallo = [
    {
        colore: E_ColoriMetallo.Nero,
        codice: "#000000",
    },
    {
        colore: E_ColoriMetallo.Antracite,
        codice: "#060202",
    },
    {
        colore: E_ColoriMetallo.Bianco,
        codice: "#a5a5a5",
    },
];